const getters = {
  personalInfo: (state) => state.menu.personalInfo, // 前登陆的用户信息
  acountList: (state) => state.menu.acountList, // 账号列表
  serviceList: (state) => state.menu.serviceList, // 服务列表
  currentUser: (state) => state.menu.currentUser, // 当前登录账号信息
  consolemoduleList: (state) => state.menu.consolemoduleList, // 门户权限
  registerMicroApps: (state) => state.menu.registerMicroApps, // 门户内置所有子应用appCode
  consoleMenulist: (state) => state.menu.consoleMenulist, // 子应用门户列表
  microApp: (state) => state.menu.microApp, // 子应用实例
  subappMenuList: (state) => state.menu.subappMenuList, // 子应用菜单列表
  subappCode: (state) => state.menu.subappCode, // 子应用appcode
  subappPermission: (state) => state.menu.subappPermission, // 子应用权限
  subviewBreadcrumb: (state) => state.menu.subviewBreadcrumb, // 子应用路由matched
  hiddenBreadcrumb: (state) => state.menu.hiddenBreadcrumb, // 子应用面包屑是否显示
  subappClassName: (state) => state.menu.subappClassName, // 子应用打包根的class类名
  mountappLoaded: (state) => state.menu.mountappLoaded, // 子应用加载完成状态
  websiteConfig: (state) => state.websiteConfig.config,
  sidebar: (state) => state.app.sidebar
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js